module.exports = __webpack_public_path__ + "img/18-workshop.18e556fc.jpg";